export const getBenefitsByGroup = (group, data) => data
  .filter(benefit => benefit.non_saving_group.name === group).map((benefit, index) => ({
    label: benefit.name,
    value: benefit.name,
    id: benefit.id,
    index: index + 1,
    group_id: benefit.non_saving_group?.id,
  }));